import { gql } from '@apollo/client'

export const ATTEND_EVENT_WITHOUT_ACCOUNT = gql`
    mutation RequestAttendance($input: attendEventWithoutAccountInput!) {
        attendEventWithoutAccount(input: $input) {
            entity {
                guid
                ... on Event {
                    title
                }
            }
        }
    }
`
